import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { OrderPipe } from 'ngx-order-pipe';
import { BaseComponent } from '../../base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { CbService } from 'src/app/services/contentbuilder/contentbuilder.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';



@Component({
  selector: 'app-contentBuilderField',
  templateUrl: './content-builder-field.component.html',
  styleUrls: ['./content-builder-field.component.css']
})
export class ContentBuilderFieldComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  public themeObj: any = [];
  totalCount: number = 0;
  ord = 'asc';
  colname = "field_name";
  limit = 10;
  offset = 0;
  page = 1;
  checked = false;
  getCompanyobj;
  currentUser;
  companyID: any = '';

  today: number = Date.now();
  constructor(
    private clientService: ClientService,
    private cb: CbService) {
      super();
  }

  ngOnInit() {
    this.getCompany();
  }

  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.offset = 0;
          this.page = 1;
          this.ngxSpinnerService.show();
        }),
        switchMap(data => this.cb.getCompanyField(this.companyID, this.limit, this.offset, this.colname, this.ord, this.searchText.nativeElement.value))
      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.themeObj = [] }
          else { this.themeObj = res.data.rows }
          this.totalCount = res.data.total;
        } else {
          this.themeObj = [];
          this.totalCount = 0;
        }
        this.ngxSpinnerService.hide();
      });
  }

  companyChange(company) {
    this.page = 1;
    this.companyID = company;
    if(this.companyID == 0){this.themeObj = [];this.totalCount = 0;this.page = 1;return}
    this.getCompanyField();
  }


  setOrder(value: string) {
    this.colname = value;
    if (this.ord == 'asc') {
      this.ord = 'desc'
    } else { this.ord = 'asc' }
    this.getCompanyField();
  }

  templateLogData() {
    let themeLogs = {
      log_type: "Template Content Builder Field View",
      log_name: "Template Content Builder Field View",
      log_description: "Template Content Builder Field View",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {
      //  console.log(data);

    }, error => {
      // console.log(error);
    });

  }

  getCompanyField() {
    let searchTerm = this.searchText.nativeElement.value;
    this.offset = (this.page - 1) * this.limit;
    this.ngxSpinnerService.show();
    this.cb.getCompanyField(this.companyID, this.limit, this.offset, this.colname, this.ord, searchTerm).subscribe(data => {
      if (data.status) {
        if (data.data.rows == null) { this.themeObj = [] }
        else { this.themeObj = data.data.rows }
        this.totalCount = data.data.total;
        this.ngxSpinnerService.hide();
      } else {
        this.themeObj = [];
        this.totalCount = 0;
        this.ngxSpinnerService.hide();
      }
    }, error => {
      //  console.log(error);
      this.ngxSpinnerService.hide();
    });
  }

  editField(id) {
    this.router.navigate(['/corporate/add-content-builder-field'], { queryParams: { companyID: this.companyID, id: id } });
  }

  deleteField(id) {
    let obj = {
      id: id,
    }
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.cb.deleteTemplateField(this.companyID, id).subscribe(data => {
            if (data.status) {
              this.getCompanyField()
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
            // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateStatus(event, id, status) {
    event.preventDefault();
    let obj = this.themeObj.find(element => {
      if (element.fieldid === id) {
        return true;
      }
    });
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          obj.isactive = !obj.isactive;
          obj.company = this.companyID;
          this.cb.updateFieldStatus(obj).subscribe(data => {
            this.getCompanyField()
            this.toastrService.success("Field Status Changed Successfully ")
            this.ngxSpinnerService.hide();
          });
        } else {
        }
      }).catch((err) => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }

  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data || [];
      this.watchWorkingCompany('companyID', () => this.getCompanyobj, (id) => this.companyChange(id));
    }, error => {
      this.getCompanyobj = [];
    });
  }
}